var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"accountData":_vm.accountData},on:{"loginSucces":_vm.loginSucces,"logout":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }